import { useTranslation } from 'react-i18next';
import type { SplitMember } from '../../hooks/useSplitMembers';

/** Who the expense is split between. Shared by the manual form and the AI review. */
export function SplitPicker({ members, selected, onToggle, perPerson, currency }: {
  members: SplitMember[];
  selected: Set<string>;
  onToggle: (id: string) => void;
  /** Already-formatted share per person, or null when there's nothing to divide yet. */
  perPerson: string | null;
  currency: string;
}) {
  const { t } = useTranslation();
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="label mb-0">{t('expenses.form.splitBetween')}</label>
        {perPerson && (
          <span className="text-xs font-semibold text-teal-600">
            {t('expenses.form.perPerson', { currency, amount: perPerson })}
          </span>
        )}
      </div>
      <div className="space-y-1.5">
        {members.map(member => {
          const active = selected.has(member.id);
          return (
            <button
              key={member.id}
              type="button"
              onClick={() => onToggle(member.id)}
              className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl border text-left transition-all cursor-pointer ${
                active
                  ? 'border-teal-300 bg-teal-50'
                  : 'border-slate-200 bg-white opacity-50'
              }`}
            >
              <div className={`w-4 h-4 rounded border-2 flex items-center justify-center shrink-0 transition-colors ${
                active ? 'border-teal-500 bg-teal-500' : 'border-slate-300'
              }`}>
                {active && <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 10 8"><path d="M1 4l3 3 5-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>}
              </div>
              <span className={`text-sm flex-1 ${active ? 'font-medium text-slate-800' : 'text-slate-400'}`}>
                {member.label}
              </span>
              {active && perPerson && (
                <span className="text-xs font-semibold text-teal-600">{currency} {perPerson}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
